import { Link } from "react-router-dom";
import { clipList } from "@/utils/catalog";
import ClipCard from "@/components/feature/ClipCard";

export default function FeaturedClips() {
  const featured = clipList.slice(0, 3);

  return (
    <section className="py-14">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground-900">精彩片段推荐</h2>
            <p className="mt-2 text-sm text-foreground-500">精选剧情回顾、对白与花絮，随时重温。</p>
          </div>
          <Link
            to="/category/clip"
            className="inline-flex items-center gap-1 text-sm text-primary-600 transition hover:text-primary-700"
          >
            更多片段<i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {featured.map((clip) => (
            <ClipCard key={clip.id} clip={clip} />
          ))}
        </div>
      </div>
    </section>
  );
}